import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetChannelDistributionSectionTemplate,
  usePutChannelDistributionTemplate,
} from 'services/templates/channel-distribution-template';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditChannelDistributionSectionTemplate = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const merchDistribution = useGetChannelDistributionSectionTemplate(id);

  const updateChannelDelivery = usePutChannelDistributionTemplate(id);

  const goBackToChannelDistribution = () =>
    navigate(`/templates-extended/merch-distribution/${id}/form`);

  const onUpdateChannelDistributionSection = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    const distribution =
      middleware.template.merchDistribution.formToQuery(values);

    if (distribution) {
      await updateChannelDelivery.mutateAsync(distribution, {
        onSuccess: goBackToChannelDistribution,
        onError: error => onErrorShowAllErrorsToast(error),
      });
    }
  };

  return (
    <Form.Contract
      tittle={`${t('button.edit')} ${
        merchDistribution.data?.title ??
        t('contract-template.merchDistribution.title')
      }`}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToChannelDistribution}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t(`button.save`)} />
        </Button>
      }
      initialStatus={contractTemplateUtil.distribution.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: merchDistribution.data
          ? middleware.template.merchDistribution.queryToForm(
              merchDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(
              TEMPLATE_TYPE.merchDistribution
            ),
      }}
      onSubmit={onUpdateChannelDistributionSection}
      status={{ isLoading: merchDistribution.isLoading }}
    />
  );
};

export default EditChannelDistributionSectionTemplate;
